<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.q" placeholder="搜索"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="$refs.editor.show()">新增</el-button>
        </el-form-item>

        <el-form-item style="margin-left: 20px;">
          <el-link type="primary" href="https://mp.weixin.qq.com/s/6G-WjS6Na0e1RQhZu7y5aQ"
            target="_blank">文件夹使用方法</el-link>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="listdata" highlight-current-row v-loading="loading" @selection-change="selsChange"
      style="width: 100%;">
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column label="名称" sortable>
        <template slot-scope="{row}">
          <a :href="'http://jazpan.com/box/' + row.Id" target="_blank">
            <img class="flicon" src="//static.jazpan.com/img/flbox.png" />
            {{ row.Name }}
          </a> &nbsp; <a style="font-size:11px;color:red" target="_blank" :href="'http://jazpan.com/user/'+row.Uid" v-if="row.infoMap.pined==true">[置顶]</a>
        </template>
      </el-table-column>
      <el-table-column prop="Timestr" label="创建时间" width="180" sortable>
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template scope="{row}">
          <el-link type="primary" :underline="false" @click="$router.push('/file/boxfls?boxid=' + row.Xid)">管理</el-link>
          <img class="btnQr" src="//static.jazpan.com/img/qrcode.png"
            @click="$refs.qrcoder.show('https://jazpan.com/box/' + row.Id,'https://m.jazpan.com/xcx/qrgoto/box?'+row.Id)" />
          <i class="btnQr el-icon-edit-outline" style="color:#db3939" @click="$refs.editor.show(row)"></i>
          <i class="btnQr el-icon-delete" style="color:#db3939" @click="handleDel(row)"></i>
          <el-tooltip class="item" effect="dark" :content="(row.infoMap.pined == true ? '取消置顶' : '置顶') + '在个人主页'"
            placement="top">
            <i class="btnQr el-icon-top" style="color:#db3939" @click="pinUserFun(row.Xid)"></i>
          </el-tooltip>
          <!-- <el-button-group>
            <el-button size="small" type="info" @click="$router.push('/file/boxfls?boxid=' + row.Xid)">管理文件</el-button>
            <el-button size="small" type="warning" @click="$refs.editor.show(row)">编辑</el-button>
            <el-button size="small" type="danger" @click="handleDel(row)">删除</el-button>
          </el-button-group> -->
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination layout="prev, pager, next" :current-page.sync="filters.page" :total="total" :page-size="limit"
        @current-change="getList" style="float:right;">
      </el-pagination>
    </el-col>
    <FlboxForm ref="editor" @submitOK="getList" />
    <Qrcode ref="qrcoder" />
  </section>
</template>

<script>
import util from '@/common/js/util'
import FlboxForm from './FlboxForm';
import Qrcode from './Qrcode';

export default {
  components: { FlboxForm, Qrcode },
  data() {
    return {
      filters: {
        page: 1,
        s: '',
        q: ''
      },
      loading: false,
      total: 0,
      limit: 0,
      listdata: [],
      sels: [],//列表选中列
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取列表
    getList() {
      this.loading = true;
      //NProgress.start();
      this.$post('/user/boxs', this.filters).then((res) => {
        console.log(res);
        this.loading = false;
        this.listdata = res.data.Data;
        this.total = res.data.Total;
        this.limit = res.data.Size;
        this.filters.page = res.data.Page;
        //NProgress.done();
      }).catch(err => {
        this.$message({
          message: err.response.data || '服务器错误',
          type: 'error'
        });
      });
    }, selsChange(sels) {
      this.sels = sels;
    }, handleAdd() {

    }, handleEdit() {

    }, handleDel(et) {
      this.$confirm('确定要删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('/user/boxdel', { xid: et.Xid }).then(res => {
          //this.$message('操作成功');
          this.getList();
        }).catch(err => {
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }, batchRemove() {

    }, pinUserFun (xid) {
      this.$confirm('确定置顶该文件夹吗? (置顶后可以到个人主页查看)', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('/user/flpin', { typ:0,xid: xid }).then(res => {
          this.$message('操作成功');
          this.getList();
        }).catch(err => {
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }
  }
}

</script>

<style scoped>
.wxmpTit {
  line-height: 60px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.wxmpTit img {
  width: 60px;
  height: 60px;
  float: left;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// FlboxList.vue?0b04e3f6